import React from 'react';
import { styled } from '@mui/material/styles';
import { User } from 'features/users/types';
import { HandRaiseBadge } from 'features/streaming/components/HandRaiseBadge';
import { ReactionBadge } from 'features/streaming/components/ReactionBadge';
import { useVisibleUserBadges } from 'features/streaming/hooks/useVisibleUserBadges';

const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  position: 'absolute',
  zIndex: 10,
  top: 8,
  left: 8,
}));

type UserBadgesProps = {
  user: User;
};

export const UserBadges = ({ user }: UserBadgesProps) => {
  const { showReaction, showHandRaise } = useVisibleUserBadges(user);

  if (!showReaction && !showHandRaise) {
    return null;
  }

  return (
    <Root>
      {showReaction && user.reaction && <ReactionBadge reaction={user.reaction} />}
      {showHandRaise && <HandRaiseBadge />}
    </Root>
  );
};
